import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';

const AdminHome = () => {
    const { portfolioData } = useSelector((state) => state.root);
    const heroSection = portfolioData?.heroSection || {};

    const name = heroSection?.name;
    const intro = portfolioData?.intro || {};
    const img = intro?.img;
    const [currentTime, setCurrentTime] = useState(new Date());
    useEffect(() => {
        // Update the current time every second
        const interval = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);

        // Cleanup the interval on component unmount
        return () => clearInterval(interval);
    }, []);

    // Format the time as per your requirements
    const formattedTime = currentTime.toLocaleTimeString();
    return (

        <>
            <div className='px-5 flex flex-col gap-8 sm:px-2 sm:gap-5 pb-8'>
                <div className='flex justify-between gap-2 sm:flex-col'>
                    <span className='font-semibold text-xl'> Welcome <strong className='border-b-2 border-secondary/80 cursor-pointer'> {name}</strong> <span>&#128075;</span>  </span>

                    <span className='font-semibold'>Current Time: &nbsp;<strong>{formattedTime}</strong></span>
                </div>
                <div className="flex  gap-4 px-8 items-center justify-between py-8 sm:flex-col sm:items-start">
                    <div>
                        <img className='shadow-lg admin-img  devimg sm:w-fit' src={img} alt="" />
                    </div>

                    <div className='flex gap-4  p-3 sm:flex-col sm:p-1 sm:w-fit '>
                        <div className="flex">
                            <div className="card h-28 flex flex-col gap-5 bg-primary dark:bg-bg-dark p-4 rounded cursor-pointer ease-in-out">
                                <p className='font-semibold text-xl text-tertiary'>Total Experiences</p>
                                <p className='flex font-bold text-xl text-secondary ml-auto count'>    {portfolioData?.experiences ? String(portfolioData.experiences.length).padStart(2, '0') : '00'}</p>
                            </div>
                        </div>
                        <div className="flex">
                            <div className="card h-28 flex flex-col gap-5 bg-primary dark:bg-bg-dark p-4 rounded cursor-pointer  ease-in-out">
                                <p className='font-semibold text-xl text-tertiary'>Total Projects</p>
                                <p className='flex font-bold text-xl text-secondary ml-auto count'>    {portfolioData?.projects ? String(portfolioData.projects.length).padStart(2, '0') : '00'}</p>
                            </div>
                        </div>

                    </div>
                </div>


            </div>
        </>
    )
}

export default AdminHome
